import { render, staticRenderFns } from "./paymentSuccess.vue?vue&type=template&id=0f1469f6&"
import script from "./paymentSuccess.vue?vue&type=script&lang=js&"
export * from "./paymentSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports